import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isPatientFacingPath } from '../utils/patientRoomAccess';
import { installPatientBackGuard } from '../utils/patientBackGuard';

/**
 * Global lock for all patient pages after QR scan:
 * Back stays on this room/call; close/refresh asks the patient to stay.
 */
const PatientPageLock = () => {
    const location = useLocation();
    const cleanupRef = useRef(null);

    useEffect(() => {
        const path = location.pathname || '';
        if (!isPatientFacingPath(path)) {
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            return undefined;
        }

        const stickyHref = `${path}${location.search || ''}${location.hash || ''}`;

        if (cleanupRef.current && typeof cleanupRef.current.updateStickyHref === 'function') {
            cleanupRef.current.updateStickyHref(stickyHref);
            return undefined;
        }

        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
        }
        cleanupRef.current = installPatientBackGuard({
            stickyHref,
            warnOnClose: true,
            depth: 12,
        });

        return undefined;
    }, [location.pathname, location.search, location.hash]);

    useEffect(() => () => {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
    }, []);

    return null;
};

export default PatientPageLock;
